import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import {
  ShareButtons,
  generateShareIcon,
} from 'react-share'
import CopyText from 'components/_molecules/CopyText'
import './styles.css'

const {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
} = ShareButtons

const FacebookIcon = generateShareIcon('facebook')
const TwitterIcon = generateShareIcon('twitter')
const WhatsappIcon = generateShareIcon('whatsapp')
const EmailIcon = generateShareIcon('email')

class SocialShare extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    separator: PropTypes.string,
    size: PropTypes.number,
    round: PropTypes.bool,
    url: PropTypes.string.isRequired,
    showLabels: PropTypes.bool,
    hashtags: PropTypes.arrayOf(
      PropTypes.string
    ),
  }

  static defaultProps = {
    description: '',
    separator: ' | ',
    size: 32,
    round: true,
    showLabels: true,
    hashtags: [],
  }

  render() {
    const {
      title,
      separator,
      hashtags,
      size,
      round,
      url,
      description,
      showLabels,
    } = this.props

    const btnProps = {
      url,
    }

    const iconProps = {
      size,
      round,
    }

    const hashTag = hashtags.length ? `#${hashtags[0]}` : ''

    let emailBody = ''
    if (description) {
      emailBody += `${description}\n\n${url}`
    } else {
      emailBody = url
    }

    return (
      <div className="SocialShare">

        <div className="social-share-buttons">
          <FacebookShareButton
            {...btnProps}
            quote={title}
            hashtag={hashTag}
          >
            <FacebookIcon {...iconProps} />
            {showLabels && (<span className="social-button-label">FaceBook</span>)}
          </FacebookShareButton>

          <TwitterShareButton
            {...btnProps}
            title={title}
            hashtags={hashtags}
          >
            <TwitterIcon {...iconProps} />
            {showLabels && (<span className="social-button-label">Twitter</span>)}
          </TwitterShareButton>

          <WhatsappShareButton
            {...btnProps}
            title={title}
            separator={separator}
          >
            <WhatsappIcon {...iconProps} />
            {showLabels && (<span className="social-button-label">WhatsApp</span>)}
          </WhatsappShareButton>

          <EmailShareButton
            {...btnProps}
            subject={title}
            body={emailBody}
          >
            <EmailIcon {...iconProps} />
            {showLabels && (<span className="social-button-label">Email</span>)}
          </EmailShareButton>
        </div>

        <CopyText text={btnProps.url} />

      </div>
    )
  }
}

export default SocialShare



// WEBPACK FOOTER //
// ./src/components/_molecules/SocialShare/index.js